import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Customização Líder — etiquetas por grupo: agentes (SDRs/vendedores) também acessam a
// tela de Configurações → Etiquetas (nativo era 'administrator' apenas). A trava fina
// (agente só gerencia as do próprio grupo) é feita na UI + no backend (labels_controller).
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          meta: {
            permissions: ['administrator', 'agent'],
          },
          redirect: to => {
            return { name: 'labels_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'labels_list',
          meta: {
            featureFlag: FEATURE_FLAGS.LABELS,
            permissions: ['administrator', 'agent'],
          },
          component: Index,
        },
      ],
    },
  ],
};
